import React from 'react'

export default function TrustStore() {
  return (
    <div>TrustStore</div>
  )
}
